import { render, staticRenderFns } from "./MyProjectsSectionHeader.vue?vue&type=template&id=e45fec8e&scoped=true"
import script from "./MyProjectsSectionHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyProjectsSectionHeader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MyProjectsSectionHeader.vue?vue&type=style&index=0&id=e45fec8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45fec8e",
  null
  
)

export default component.exports